import { useTranslation } from "next-i18next";
import Image from "next/image";

const WhatIsCloudServer = () => {
    const { t } = useTranslation(["common", "cloudServer"]);
    return (
        <div className="pt-16 bg-buttonBg">
            <div className="container mx-auto">
                <h2 className="relative z-10 text-3xl font-bold text-center lg:text-4xl text-titleColor text-after-shadow-cloud">{t("cloudServer:whatIsCloudServer")}</h2>
                <div className="pt-8 text-center text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:whatIsCloudServerDesc") }}></div>

                <div className="flex items-center justify-center pt-16">
                    <Image src={"/whatIsCloudServer.png"} width={797} height={537} alt={t("cloudServer:whatIsCloudServer")} title={t("cloudServer:whatIsCloudServer")} />
                </div>
            </div>
        </div>
    )
}

export default WhatIsCloudServer